import { Locale } from '../models/common.model';
export const DEFAULT_LOCALE = Locale.EN;
export const DEFAULT_NAVIGATION_EXTRAS = {
    queryParamsHandling: 'merge',
};
